import { Medal } from "lucide-react";

export function QuestRace({ race }) {
  if (!race) return null;
  const hero = race.rank && race.rank <= 3;
  return (
    <div className={`rounded-3xl p-5 flex items-center gap-4 border-2 ${hero ? "bg-gradient-to-r from-amber-100 via-yellow-50 to-amber-100 border-amber-300" : "bg-white border-amber-200"}`} data-testid="quest-race">
      <div className={`w-14 h-14 shrink-0 rounded-full flex items-center justify-center ${hero ? "bg-gradient-to-br from-yellow-300 to-amber-500 text-amber-950 shadow-lg shadow-amber-300/60" : "bg-amber-50 text-amber-500"}`}>
        <Medal className="w-7 h-7" />
      </div>
      <div className="min-w-0">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-amber-600">Helden-Rennen live</p>
        <p className="font-display text-lg font-extrabold text-slate-900" data-testid="quest-race-text">
          {hero ? `Du bist auf Heldenkurs – Platz ${race.rank}!` : `Noch ${race.need} ${race.need === 1 ? "Beitrag" : "Beiträge"} bis Platz 3!`}
        </p>
        <p className="text-xs text-slate-500">{hero ? "Bleib dran – wird die Aufgabe geschafft, bekommst du das goldene Aufgaben-Held-Abzeichen." : `Die Top 3 einer geschafften Aufgabe werden Aufgaben-Helden.${race.rank ? ` Du bist gerade auf Platz ${race.rank}.` : ""}`}</p>
      </div>
    </div>
  );
}
